<template>
  <router-view />
</template>
<script setup>
  import { nextTick, onMounted } from 'vue'
  import { useDevice } from 'src/modules/app/composables/useDevice.js'

  const { isNativeCallAvailable, callNative } = useDevice()

  onMounted(() => {
    // Hide global Loading Screen
    const loadingScreen = document.getElementById('loading-screen')
    if (loadingScreen) {
      loadingScreen.style.display = 'none'
    }
  })

  if (isNativeCallAvailable()) {
    onMounted(() => {
      nextTick(async () => {
        await callNative('hideLoadingScreen', '', null)
      })
    })
  }
</script>
